module.exports = __webpack_public_path__ + "public/images/blob_left.d58850a7d39f2e6786afeb967d05014a.png";